import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import DropzoneSwipe from '@/components/share/dropzone_swipe'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from 'tiptap-extensions'
import axios from 'axios'
import {scroller} from 'vue-scrollto/src/scrollTo'
const firstScrollTo = scroller()

let ndt = new Date()
var dt = `${ndt.getFullYear()}-${ndt.getMonth() + 1 >= 10 ? ndt.getMonth() + 1 : '0' + (ndt.getMonth() + 1)}-${ndt.getDate() + 1 >= 10 ? ndt.getDate() + 1 : '0' + (ndt.getDate() + 1)}`

export default {
  name: 'swipeEdit',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar,
    DropzoneSwipe,
    EditorContent,
    EditorMenuBar
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    },
    cover () {
      if (this.selected.type === 0 || this.ogp.status === 2) {
        return `${this.env.S3}/enterprise/swipe/${this.selected.coverId}.png`
      } else if (this.selected.type !== 0 && this.ogp.status === 1) {
        return this.ogp.image
      }
    },
    typeState () {
      return this.selected.type === 0 || this.ogp.status > 0
    },
    categoryState () {
      return this.selected.category === 0 || this.selected.category
    },
    titleState () {
      return this.selected.title.length > 0
    },
    descriptionState () {
      return this.selected.description.length > 0 && this.selected.description !== '<p><br></p>' && this.selected.description !== '<h1></h1>'
    },
    coverState () {
      return this.selected.coverId
    },
    eventState () {
      return this.selected.category !== 5 || this.selected.eventDates[0]
    },
    questionState () {
      return this.selected.questionnaire === 0 || (this.selected.questionnaire === 1 && this.selected.questionnaireTitle && this.selected.questionnaireList.length && this.selected.questionnaireList[0])
    },
    themeState () {
      return this.selected.theme.length > 0
    },
    segmentState () {
      return this.selected.segment === 0 || (this.selected.segment === 1 && this.selected.segmentOption.length > 0)
    },
    scheduleState () {
      return this.selected.schedule === 0 || this.selected.scheduleDate
    },
    countState () {
      return this.selected.swipeCount && this.selected.swipeCount > this.swiped && this.selected.swipeCount <= this.swipeCount
    },
    nextState () {
      return this.categoryState &&
             this.typeState &&
             this.titleState &&
             this.descriptionState &&
             this.coverState &&
             this.questionState &&
             this.themeState &&
             this.segmentState
    },
    publishState () {
      return this.categoryState &&
             this.typeState &&
             this.titleState &&
             this.descriptionState &&
             this.coverState &&
             this.questionState &&
             this.themeState &&
             this.segmentState &&
             this.scheduleState &&
             this.countState
    },
    minDate () {
      return dt
    }
  },
  data () {
    return {
      loading: false,
      updating: {
        draft: false,
        next: false,
        publish: false
      },
      alert: {
        message: '',
        dismissSecs: 2,
        dismissCountDown: 0,
        variant: ''
      },
      modalAlert: {
        message: '',
        dismissSecs: 2,
        dismissCountDown: 0,
        variant: ''
      },
      title: '',
      description: '',
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History()
        ],
        content: '内容を入力しましょう！',
        onUpdate: ({ getJSON, getHTML }) => {
          this.selected.description = getHTML().replace(/<p><\/p>/g, '<p><br></p>')
        }
      }),
      category: [
        {
          name: '会社情報',
          icon: ['fas', 'building'],
          description: '会社の事業内容や規模などの基本情報を載せましょう。'
        },
        {
          name: '社員情報',
          icon: ['fas', 'portrait'],
          description: '活躍社員の経歴やインタビューなどを載せましょう。'
        },
        {
          name: '職場情報',
          icon: ['fas', 'map-marker-alt'],
          description: '社内環境など、働く姿がイメージできるような情報を載せましょう。'
        },
        {
          name: '新卒採用情報',
          icon: ['fas', 'user-tie'],
          description: '新卒採用求人や選考情報などを載せましょう。'
        },
        {
          name: 'インターン採用情報',
          icon: ['fas', 'school'],
          description: 'インターン募集情報を載せましょう。'
        },
        {
          name: 'イベント情報',
          icon: ['fas', 'bullhorn'],
          description: 'イベントの告知や開催情報を載せましょう。'
        },
        {
          name: 'リリース情報',
          icon: ['fas', 'info-circle'],
          description: '新規事業・新製品などのリリース情報を載せましょう。'
        },
        {
          name: '記事情報',
          icon: ['fas', 'rss-square'],
          description: '他媒体で公開中の記事などを載せましょう。'
        },
        {
          name: 'アルバイト採用情報',
          icon: ['fas', 'coffee'],
          description: 'アルバイト採用情報を載せましょう。'
        }
      ],
      type: ['オリジナル', 'リンク', 'YouTube'],
      segment: {
        option: ['設定しない', '設定する'],
        data: {},
        selectOption: [
          {value: null, text: '属性を選択してください'},
          {value: 'job', text: '希望職種'},
          {value: 'study', text: '学問'},
          {value: 'school', text: '学校'},
          {value: 'graduateYear', text: '卒業年'},
          {value: 'area', text: 'エリア'}
        ],
        selecting: false,
        selected: null,
        input: '',
        loading: false,
        cnt: 0,
        selectedList: []
      },
      schedule: ['設定しない', '設定する'],
      questionnaire: ['設定しない', '設定する'],
      theme: [],
      selected: {
        category: '',
        type: '',
        title: '',
        description: '',
        coverId: '',
        coverStatus: '',
        segment: 0,
        segmentOption: [],
        segmentExpanded: true,
        theme: [],
        schedule: 0,
        scheduleDate: dt,
        questionnaire: 1,
        questionnaireTitle: '興味なしにした理由について、当てはまるものを全て選択してください。',
        questionnaireList: ['', '', ''],
        url: '',
        siteName: '',
        eventDates: [''],
        swipeCount: '',
        eventMessage: '',
        isEventMessage: false,
        autoMessage: '',
        isAutoMessage: false,
        includeMessaged: false
      },
      state: {},
      error: {},
      dz: {
        uploaded: false,
        loading: false
      },
      status: 1,
      preview: 1,
      ogp: {
        loading: false,
        status: 0,
        data: {},
        url: '',
        image: '',
        error: ''
      },
      dateTimeConfig: {
        disabledHours: ['00', '01', '02', '03', '04', '05', '06', '07', '22', '23']
      },
      isBook: false,
      swipeCount: 0,
      manageId: '',
      planId: '',
      swiped: 0,
      eventSelected: ''
    }
  },
  mounted () {
    this.loading = true
    if (this.$route.query.id) this.fetchData(this.$route.query.id)
    else this.fetchMaster()

    if (!this.selected.eventMessage) {
      this.selected.eventMessage = `こんにちは！${this.user.name}の＿＿と申します。\n\n` +
        `このたびは、 「{title}」のカードへ興味を持っていただきありがとうございます。\n` +
        `{name}さんのプロフィールを拝見しまして非常に興味を持っております。\n` +
        `せひ一度、弊社の新卒採用/インターン採用の選考について、詳細含めた説明会にご参加いただきたいのですが、以下の日程にてご都合いかがでしょうか？\n\n` +
        `ご返信お待ちしております！\n\n` +
        `▼開催場所\n` +
        `${this.user.address}\n\n` +
        `▼所要時間\n` +
        `1時間程度`
    }

    if (!this.selected.autoMessage) {
      this.selected.autoMessage = `こんにちは！${this.user.name}の＿＿と申します。\n\n` +
        `このたびは、 「{title}」のカードへ興味を持っていただきありがとうございます。\n` +
        `{name}さんのプロフィールを拝見しまして非常に興味を持っております。\n\n` +
        `よろしければカジュアルな形でオフィスまたはオンラインにてお話ができればと思っております。\n` +
        `一時間ほどお話しをして、弊社のことをより知っていただく機会になればと思います。\n` +
        `弊社や弊社のサービスをご紹介した上で、{name}さんのやりたいことや興味のあることをお聞きできれば幸いです！\n\n` +
        `ご返信お待ちしております！`
    }
  },
  methods: {
    fetchMaster () {
      axios.get(`${this.env.APIG.invokeStuUrl}${this.api.MASTER}?type=theme`)
        .then(response => {
          this.theme = response.data
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchData (swipeId) {
      axios.get(`${this.env.APIG.invokeStuUrl}${this.api.MASTER}?type=theme`)
        .then(response => {
          this.theme = response.data

          let pathParams = {
            swipeId
          }

          let additionalParams = {
            queryParams: {
              type: 'edit'
            }
          }

          this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
            .then(response => {
              for (let key in response.data) {
                if (key !== 'status' && key !== 'manageId') this.selected[key] = response.data[key]
                else if (key === 'status') this.status = response.data[key]
                else this.manageId = response.data[key]

                if (key === 'description') this.editor.setContent(response.data.description.replace(/<p><br><\/p>/g, '<p></p>'))
                if (key === 'theme') {
                  for (let i in this.theme) {
                    if (this.selected.theme.indexOf(this.theme[i].theme_cd) !== -1) this.theme[i].isAdd = true
                  }
                }
              }

              if (this.selected.type !== 0 && this.selected.coverId) {
                if (!this.selected.coverStatus) {
                  this.ogp.status = 1
                  this.ogp.image = this.selected.coverId
                } else {
                  this.ogp.status = 2
                }
                this.ogp.url = this.selected.url
              }

              if (this.selected.segment === 1) {
                this.selectSegment(this.selected.segment, true)

                if (this.selected.segmentOption.length) {
                  this.segment.selected = this.selected.segmentOption[0].type
                  for (let item of this.selected.segmentOption) {
                    this.segment.selectedList.push(item.value)
                  }
                }

                this.loading = false
              } else this.loading = false
            })
            .catch(err => {
              console.log(err)
            })
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchLink () {
      if (this.selected.url) {
        this.ogp.loading = true
        this.dz.loading = true
        this.ogp.error = ''

        let pathParams = {
          swipeId: this.selected.url
        }

        let additionalParams = {
          queryParams: {
            type: 'link'
          }
        }

        this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
          .then(response => {
            this.ogp.status = 1
            this.selected.coverStatus = 0
            this.ogp.data = response.data
            if (this.ogp.data.ogTitle) this.selected.title = this.ogp.data.ogTitle
            if (this.ogp.data.ogDescription) {
              this.selected.description = `<p>${this.ogp.data.ogDescription}</p>`
              this.editor.setContent(`<p>${this.ogp.data.ogDescription}</p>`)
            }
            if (this.ogp.data.ogImage && this.ogp.data.ogImage.url) {
              this.selected.coverId = this.ogp.data.ogImage.url
              this.ogp.image = this.ogp.data.ogImage.url
            }
            this.selected.siteName = this.selected.url.match(/^https?:\/{2,}(.*?)(?:\/|\?|#|$)/)[1]
            this.ogp.url = this.selected.url

            firstScrollTo('#step')
            this.ogp.loading = false
            this.dz.loading = false
          })
          .catch(err => {
            console.log(err)
            this.ogp.error = 'リンクからデータを取得できませんでした。正しいURLを入力してください。'
            this.ogp.loading = false
            this.dz.loading = false
          })
      }
    },
    countDownChanged (dismissCountDown) {
      this.alert.dismissCountDown = dismissCountDown
    },
    modalCountDownChanged (dismissCountDown) {
      this.modalAlert.dismissCountDown = dismissCountDown
    },
    setTemplate (index) {
      this.selected.category = index
    },
    getDropzoneData (data) {
      this.dz.loading = true

      setTimeout(() => {
        if (this.selected.type === 1) this.ogp.status = 2
        this.selected.coverStatus = 1
        this.dz.uploaded = data.isUpload
        this.selected.coverId = data.coverId
        this.dz.loading = false
      }, 1000)
    },
    click (item, key) {
      if (this.selected.theme.indexOf(item.theme_cd) === -1) {
        this.selected.theme.push(item.theme_cd)
        this.theme[key].isAdd = true
      } else {
        this.selected.theme.splice(this.selected.theme.indexOf(item.theme_cd), '1')
        this.theme[key].isAdd = false
      }
    },
    updateDraft () {
      this.updating.draft = true

      if (!this.typeState || !this.categoryState) {
        this.updating.draft = false
        return
      }

      let pathParams = {}

      if (this.$route.query.id) pathParams.swipeId = this.$route.query.id
      else pathParams.swipeId = 'new'

      let additionalParams = {
        queryParams: {
          type: 'draft'
        }
      }

      if (this.manageId) additionalParams.queryParams.manageId = this.manageId

      let body = {
        category: this.category[this.selected.category].name,
        theme: [],
        selected: {questionnaireList: [], eventDates: []}
      }

      for (let key in this.selected) {
        if (key === 'questionnaireList' || key === 'eventDates') {
          for (let i in this.selected[key]) {
            if (this.selected[key][i]) body.selected[key].push(this.selected[key][i])
          }
        } else if (this.selected[key] || this.selected[key] === 0 || this.selected[key] === false) body.selected[key] = this.selected[key]
      }

      for (let item of this.theme) {
        if (item.isAdd) body.theme.push(item.name)
      }

      if (body.selected.category !== 5 || this.user.plan < 2 || this.user.plan === 99 || !body.selected.isEventMessage) {
        delete body.selected.eventMessage
        body.selected.isEventMessage = false
      } else if (!body.selected.eventMessage) {
        this.updating.draft = false
        return
      }

      if (body.selected.category === 5 || this.user.plan < 2 || this.user.plan === 99 || !body.selected.isAutoMessage) {
        delete body.selected.autoMessage
        body.selected.isAutoMessage = false
      } else if (!body.selected.autoMessage) {
        this.updating.draft = false
        return
      }

      this.$apig.patch(this.$store.getters.api.SWIPE, pathParams, additionalParams, body)
        .then(response => {
          // 成功のアラート
          this.alert.dismissCountDown = this.alert.dismissSecs
          this.alert.message = '下書きを保存しました！'
          this.alert.variant = 'success'

          if (!this.$route.query.id) this.$router.push({query: {id: response.data.swipeId}})
          else this.fetchData(this.$route.query.id)

          this.updating.draft = false
        })
        .catch(err => {
          // 失敗のアラート
          this.alert.dismissCountDown = this.alert.dismissSecs
          this.alert.message = err.response.data.message
          this.alert.variant = 'danger'
          this.updating.draft = false
        })
    },
    next () {
      this.updating.next = true

      if (!this.nextState) {
        if (!this.typeState) {
          this.state.type = false
          this.error.type = 'タイプを設定してください'
        }
        if (!this.categoryState) {
          this.state.category = false
          this.error.category = 'カテゴリーを設定してください'
        }
        if (!this.titleState) {
          this.state.title = false
          this.error.title = 'タイトルを設定してください'
        }
        if (!this.descriptionState) {
          this.state.description = false
          this.error.description = '内容を設定してください'
        }
        if (!this.coverState) {
          this.state.cover = false
          this.error.cover = 'カバー画像を設定してください'
        }
        if (!this.questionState) {
          this.state.question = false
          this.error.question = 'アンケートを設定してください'
        }
        if (!this.themeState) {
          this.state.theme = false
          this.error.theme = 'テーマを設定してください'
        }
        if (!this.segmentState) {
          this.state.segment = false
          this.error.segment = 'セグメントを設定してください'
        }
        if (!this.countState) {
          this.state.swipeCount = false
          this.error.swipeCount = '配信SWを設定してください'
        }

        this.updating.publish = false
      } else {
        let pathParams = {
          swipeId: this.$route.query.id || 'balance'
        }

        let additionalParams = {
          queryParams: {
            type: 'balance'
          }
        }

        if (this.manageId) additionalParams.queryParams.manageId = this.manageId

        this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
          .then(response => {
            this.swipeCount = response.data.count
            this.swiped = response.data.swiped
            this.isBook = true
            this.updating.next = false
          })
          .catch(err => {
            console.log(err)
            this.updating.next = false
          })
      }
    },
    publish () {
      this.updating.publish = true

      if (!this.publishState) {
        if (!this.typeState) {
          this.state.type = false
          this.error.type = 'タイプを設定してください'
        }
        if (!this.categoryState) {
          this.state.category = false
          this.error.category = 'カテゴリーを設定してください'
        }
        if (!this.titleState) {
          this.state.title = false
          this.error.title = 'タイトルを設定してください'
        }
        if (!this.descriptionState) {
          this.state.description = false
          this.error.description = '内容を設定してください'
        }
        if (!this.coverState) {
          this.state.cover = false
          this.error.cover = 'カバー画像を設定してください'
        }
        if (!this.questionState) {
          this.state.question = false
          this.error.question = 'アンケートを設定してください'
        }
        if (!this.themeState) {
          this.state.theme = false
          this.error.theme = 'テーマを設定してください'
        }
        if (!this.segmentState) {
          this.state.segment = false
          this.error.segment = 'セグメントを設定してください'
        }
        if (!this.scheduleState) {
          this.state.schedule = false
          this.error.schedule = '配信日程を設定してください'
        }
        if (!this.countState) {
          this.state.swipeCount = false
          this.error.swipeCount = '適切な配信SWを設定してください'
        }

        this.updating.publish = false
      } else {
        let pathParams = {}

        if (this.$route.query.id) pathParams.swipeId = this.$route.query.id
        else pathParams.swipeId = 'new'

        let additionalParams = {
          queryParams: {
            type: 'publish',
            planId: this.user.planId
          }
        }

        if (this.manageId) additionalParams.queryParams.manageId = this.manageId

        let body = {
          category: this.category[this.selected.category].name,
          theme: [],
          selected: {questionnaireList: [], eventDates: []}
        }

        for (let key in this.selected) {
          if (key === 'questionnaireList' || key === 'eventDates') {
            for (let i in this.selected[key]) {
              if (this.selected[key][i]) body.selected[key].push(this.selected[key][i])
            }
          } else if (this.selected[key] || this.selected[key] === 0 || this.selected[key] === false) body.selected[key] = this.selected[key]
        }

        if (this.selected.schedule === 0) body.selected.scheduleDate = dt

        for (let item of this.theme) {
          if (item.isAdd) body.theme.push(item.name)
        }

        if (body.selected.category !== 5 || this.user.plan < 2 || this.user.plan === 99 || !body.selected.isEventMessage) {
          delete body.selected.eventMessage
          body.selected.isEventMessage = false
        } else if (!body.selected.eventMessage) {
          this.updating.draft = false
          return
        }

        if (body.selected.category === 5 || this.user.plan < 2 || this.user.plan === 99 || !body.selected.isAutoMessage) {
          delete body.selected.autoMessage
          body.selected.isAutoMessage = false
        } else if (!body.selected.autoMessage) {
          this.updating.draft = false
          return
        }

        this.$apig.patch(this.$store.getters.api.SWIPE, pathParams, additionalParams, body)
          .then(response => {
            // 成功のアラート
            this.modalAlert.dismissCountDown = this.modalAlert.dismissSecs
            this.modalAlert.message = '配信予約が完了しました！'
            this.modalAlert.variant = 'success'

            this.$router.push({path: '/swipe'})
            this.updating.publish = false
          })
          .catch(err => {
            // 失敗のアラート
            this.modalAlert.dismissCountDown = this.modalAlert.dismissSecs
            this.modalAlert.message = err.response.data.message
            this.modalAlert.variant = 'danger'
            this.updating.publish = false
          })
      }
    },
    selectType (key) {
      this.selected.type = key
      if (key === 0) {
        this.selected.url = ''
        if (this.ogp.status === 1) this.selected.coverId = ''
        if (!this.ogp.status) this.ogp.status = 1
        firstScrollTo('#step')
      } else if (key === 1) {
        if (this.ogp.url) this.selected.url = this.ogp.url
        if (this.ogp.status === 1) this.selected.coverId = this.ogp.image
        if (!this.ogp.status) this.ogp.status = 1
      }
    },
    selectSegment (key, isCnt = false) {
      this.segment.selecting = true
      this.selected.segment = key

      if (key === 1) {
        let pathParams = {
          swipeId: 'segment'
        }

        let additionalParams = {
          queryParams: {
            type: 'segment'
          }
        }

        this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
          .then(response => {
            this.segment.data = response.data
            this.segment.selecting = false
            if (isCnt) this.setSegment()
          })
          .catch(err => {
            console.err(err)
          })
      } else this.segment.selecting = false
    },
    clickSegment (item) {
      this.segment.loading = true

      if (this.segment.selectedList.indexOf(item.value) === -1) {
        this.selected.segmentOption.push({
          type: this.segment.selected,
          name: item.name,
          value: item.value
        })
        this.segment.selectedList.push(item.value)
      } else {
        this.selected.segmentOption.splice(this.segment.selectedList.indexOf(item.value), 1)
        this.segment.selectedList.splice(this.segment.selectedList.indexOf(item.value), 1)
      }

      this.setSegment()
    },
    removeSegment (item, key) {
      this.selected.segmentOption.splice(key, '1')
      if (this.selected.segmentOption.length) {
        this.segment.loading = true
        this.setSegment()
      } else this.segment.cnt = 0
    },
    setSegment () {
      let segment = []
      for (let item of this.selected.segmentOption) {
        segment.push(`${item.type}_${item.value}`)
      }

      let pathParams = {
        swipeId: 'segmentCnt'
      }

      let additionalParams = {
        queryParams: {
          type: 'segmentCnt',
          segment
        }
      }

      this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.segment.cnt = response.data.reach
          this.segment.loading = false
        })
        .catch(err => {
          console.err(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/swipe/edit/edit.js